export default "__VITE_ASSET__d0c34db3__"